import { Link, useLocation, Navigate } from "react-router-dom";
import { ArrowRight, ArrowLeft, PhoneCall, Mail, MessageCircle } from "lucide-react";
import SiteFooter from "../components/SiteFooter";
import { LogoWordmark } from "../components/Logo";

const ThankYouPage = () => {
  const { state } = useLocation();
  if (!state?.lead) return <Navigate to="/get-started" replace />;
  const { name = "there", business_name = "your business" } = state.lead;
  const confirmationEmailSent = state.confirmation_email_sent !== false;
  const firstName = name.split(" ")[0];

  return (
    <div className="min-h-screen bg-[color:var(--bg)] flex flex-col" data-testid="thank-you-page">
      <header className="border-b border-[color:var(--border-soft)] bg-[color:var(--bg)]">
        <div className="max-w-[1240px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <Link to="/"><LogoWordmark size={30} /></Link>
          <Link to="/" className="btn-ghost text-[14px]">
            <ArrowLeft size={14} /> Back to home
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center py-16 lg:py-24 px-6">
        <div className="max-w-2xl w-full text-center" data-testid="thank-you-card">
          <p className="eyebrow eyebrow-accent mx-auto justify-center" style={{ display: 'inline-flex' }}>Enquiry received</p>
          <h1 className="font-display text-[44px] lg:text-[68px] leading-[1.02] tracking-tight text-[color:var(--ink)] mt-8" data-testid="thank-you-title">
            Thanks {firstName}. <span className="font-serif-italic">We're on it.</span>
          </h1>
          <p className="text-[17px] leading-relaxed text-[color:var(--muted)] mt-6 max-w-xl mx-auto">
            We've received your details for <strong className="text-[color:var(--ink)]">{business_name}</strong>.
            Elliot will personally reach out within the next <strong className="text-[color:var(--ink)]">48 hours</strong>.
          </p>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 text-left">
            {[
              { icon: PhoneCall, title: "Personal call", body: "Elliot rings or WhatsApps you within 48 hours to talk through your goals." },
              { icon: MessageCircle, title: "Free preview", body: "We design your full website first — no payment until you approve it." },
              {
                icon: Mail,
                title: confirmationEmailSent ? "Check your inbox" : "We've saved your details",
                body: confirmationEmailSent
                  ? "We've sent a confirmation from contact@readytrades.co.uk."
                  : "Your details are safe with us — Elliot will be in touch within 48 hours by phone or WhatsApp.",
              },
            ].map(({ icon: Icon, title, body }) => (
              <div key={title} className="bg-[color:var(--bg-paper)] border border-[color:var(--border-soft)] rounded-2xl p-6">
                <Icon size={18} strokeWidth={1.5} className="text-[color:var(--accent)] mb-4" />
                <p className="font-display text-[18px] text-[color:var(--ink)] mb-1.5">{title}</p>
                <p className="text-[13px] leading-relaxed text-[color:var(--muted)]">{body}</p>
              </div>
            ))}
          </div>

          <Link to="/" className="btn-secondary mt-12 inline-flex" data-testid="back-home-link">
            Back to home <ArrowRight size={14} />
          </Link>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
};

export default ThankYouPage;
